/**
 * Shape-only helpers for presence groups, kept apart from
 * use-add-presences-grouping so that pure predicates can read a group without
 * pulling in the React hook and the toolkit modules it depends on.
 */

export function resolveItemId(item: { id?: string; tempId?: string }): string {
  return item.tempId ?? item.id ?? '';
}

export function collectGroupLeafItems<T>(group: { children?: T[] } | T): T[] {
  return (group as { children?: T[] }).children ?? [group as T];
}

export function collectGroupLeafIds(group: any): string[] {
  return collectGroupLeafItems<any>(group)
    .map((c: any) => resolveItemId(c))
    .filter(Boolean);
}
